import { render, staticRenderFns } from "./ValesSolicitados.vue?vue&type=template&id=a0a119f2&"
import script from "./ValesSolicitados.vue?vue&type=script&lang=js&"
export * from "./ValesSolicitados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports